var yt = Object.defineProperty;
var _t = (e, t, r) => t in e ? yt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var G = (e, t, r) => _t(e, typeof t != "symbol" ? t + "" : t, r);
import Ht, { isCancel as Fe, AxiosError as Tt } from "axios";
import { jsx as ye } from "react/jsx-runtime";
import { toast as w } from "@systemeio/ui";
import { useState as _e, useEffect as Ve, useCallback as ie } from "react";
class Bt extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
class ke extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
class ge extends Error {
  constructor(r) {
    super(r.detail);
    G(this, "errors");
    this.errors = r, this.violationsTitleToMessage();
  }
  // TODO: delete this method after BE decide what to use title or message
  violationsTitleToMessage() {
    var r;
    (r = this.errors.violations) == null || r.forEach((n) => {
      "title" in n && (n.message = n.title, delete n.title);
    });
  }
}
class Xe extends Error {
  constructor(r) {
    var n;
    super((n = r.errors.common) == null ? void 0 : n.join(""));
    G(this, "errors");
    this.errors = r.errors;
  }
  toErrorWithViolations({
    type: r,
    status: n,
    title: i,
    code: s
  }) {
    return new ge({
      type: r,
      status: n,
      title: i,
      detail: this.message,
      violations: this.flattenObjectToViolations(this.errors.fields, s, "")
    });
  }
  flattenObjectToViolations(r, n, i = "") {
    const s = [];
    return typeof r == "string" ? (s.push({ propertyPath: i, message: r, code: n }), s) : (Array.isArray(r) ? r.length === 1 ? s.push({ propertyPath: i, message: r[0], code: n }) : r.forEach((o, a) => {
      const u = `${i}[${a}]`;
      s.push(...this.flattenObjectToViolations(o, n, u));
    }) : r !== null && typeof r == "object" && Object.entries(r).forEach(([o, a]) => {
      const u = i ? `${i}.${o}` : o;
      s.push(...this.flattenObjectToViolations(a, n, u));
    }), s);
  }
}
class je extends Xe {
  toErrorWithViolations() {
    return super.toErrorWithViolations({
      type: "",
      status: $.code,
      title: "",
      code: $.code
    });
  }
}
class $ extends ge {
}
G($, "code", 422);
class We extends Xe {
}
class $e extends Error {
  constructor(t) {
    super(t), this.name = this.constructor.name;
  }
}
class Ze extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
const St = [
  "Invalid JWT Token",
  "JWT Token not found",
  "Expired JWT Token"
];
class Or extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
class ze extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
class Nt extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
class se extends Error {
  constructor(t) {
    super(t == null ? void 0 : t.error.message), this.name = this.constructor.name;
  }
  static isNotFoundResponse(t) {
    return !(!t || typeof t != "object" || !("error" in t) || !t.error || typeof t.error != "object" || !("code" in t.error) || !("message" in t.error));
  }
}
class Je extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
class Qe extends Error {
  constructor(r) {
    super(r);
    G(this, "location");
    this.location = r;
  }
}
class Ye extends ge {
}
const qe = (e) => typeof e != "object" || Array.isArray(e) || e === null ? (console.error("field has wrong type"), !1) : Object.values(e).some(
  (t) => Array.isArray(t) ? t.length : qe(t)
);
function Mr(e = {}) {
  const { withCredentials: t = !0, headers: r = {}, baseURL: n } = e;
  return Ht.create({
    withCredentials: t,
    baseURL: n,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      ...r
    }
  });
}
const Ur = (e, t) => {
  let r = !1, n = [];
  const i = () => e.post("/api/user/token/regenerate"), s = (u) => {
    n.push(u);
  }, o = () => {
    n.forEach((u) => u()), n = [];
  }, a = async (u) => {
    const h = u.config;
    if (!r) {
      r = !0;
      try {
        return await i(), r = !1, o(), await e(h);
      } catch (l) {
        throw r = !1, n = [], l;
      }
    }
    return new Promise((l) => {
      s(() => {
        l(e(h));
      });
    });
  };
  return async (u) => {
    if (Fe(u))
      throw u;
    if (u = u, u.code === Tt.ERR_NETWORK)
      throw new Nt();
    const h = u.response;
    if (!h)
      throw u;
    switch (h.status) {
      case 400:
        throw "errors" in h.data ? new je(h.data) : new $(h.data);
      case 401:
        if (St.includes(h.data.message))
          return await a(u);
        if (h.data.location)
          throw new Qe(h.data.location);
        t == null || t.error("Unauthorized response", h.data);
        break;
      case 403:
        throw new ke();
      case 404:
        throw new se(se.isNotFoundResponse(h.data) ? h.data : void 0);
      case 409:
        throw new We(h.data);
      case 413:
        throw new Je();
      case 422:
        throw new Ye(h.data);
      case 423:
        throw new ze();
      case 424:
        throw new $e(h.data.title);
      case 500:
      case 502:
        throw new Ze();
    }
    throw u;
  };
}, Gr = ({
  httpClient: e,
  useRouter: t,
  useLocoTranslation: r
}) => function({
  method: i,
  showFieldsErrorToast: s,
  stopErrorPropagation: o,
  badRequestHandler: a,
  unauthorizedResponseHandler: u,
  unprocessableContentHandler: h,
  internalErrorHandler: l,
  afterFetch: p,
  accessDeniedHandler: f,
  onErrorBeforeErrorHandlers: x,
  onNotFound: _,
  mock: v
}) {
  const N = t(), { t: T } = r(), [I, H] = _e(0), [C, A] = _e(!1);
  return Ve(() => A(!!I), [I]), { fetcher: ie(
    async (...R) => {
      var be, xe, Ee;
      H((c) => c + 1);
      const Et = typeof process < "u" && ((be = process.env) == null ? void 0 : be.NODE_ENV) === "development" || typeof process < "u" && ((xe = process.env) == null ? void 0 : xe.NEXT_PUBLIC_APP_ENV) === "development" || typeof process < "u" && ((Ee = process.env) == null ? void 0 : Ee.APP_ENV) === "development";
      return (v && Et ? new Promise((c, ve) => {
        const vt = v.delay ?? 3e3;
        setTimeout(() => {
          v.error ? ve(v.error) : c(v.data);
        }, vt);
      }) : e[i](
        R[0],
        R[1],
        R[2]
      ).then(async (c) => c && (p ? await p(c.data, c) : c.data))).catch(x).catch(async (c) => {
        if (typeof window < "u" && c instanceof se)
          _ ? _(c) : process.env.NODE_ENV !== "development" && N.replace("/not-found");
        else if (typeof window < "u" && c instanceof ke)
          f ? f(c) : N.push("/403");
        else if (typeof window < "u" && c instanceof Qe)
          u ? u(c) : window.location.assign(c.location);
        else if (typeof window < "u" && c instanceof Ze)
          l ? l(c) : w.error(T("core.error.internal_error_message"));
        else if (c instanceof je)
          s && c.errors && qe(c.errors.fields) && w.error(T("global.errors.fields_toast_message")), a ? a(c) : c.message && w.error(/* @__PURE__ */ ye("p", { dangerouslySetInnerHTML: { __html: c.message } }));
        else if (c instanceof We)
          w.error(T("core.error.conflict_error_message"));
        else if (c instanceof Ye)
          h ? h(c) : w.error(c.message || T("core.error.conflict_error_message"));
        else if (c instanceof ze)
          w.error(c.message);
        else if (c instanceof Je)
          w.error(T("core.error.payload_to_large_error_message"));
        else if (c instanceof $e)
          w.error(/* @__PURE__ */ ye("p", { dangerouslySetInnerHTML: { __html: c.message } }));
        else {
          if (c instanceof Bt)
            throw c;
          !(Fe(c) || c.code === "ECONNABORTED") && w.error(T("global.error"));
        }
        if (!o)
          throw c;
      }).finally(() => H((c) => c - 1));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      i,
      p,
      N,
      u,
      s,
      a,
      h,
      f,
      x
    ]
  ), isFetching: C };
};
var Pt = /* @__PURE__ */ ((e) => (e.get = "get", e.delete = "delete", e.head = "head", e.options = "options", e.post = "post", e.put = "put", e.patch = "patch", e.postForm = "postForm", e))(Pt || {});
const Dr = [
  "get",
  "delete",
  "head",
  "options"
  /* options */
];
var oe = function(e, t) {
  return oe = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, oe(e, t);
};
function z(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  oe(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var P = function() {
  return P = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var s in r) Object.prototype.hasOwnProperty.call(r, s) && (t[s] = r[s]);
    }
    return t;
  }, P.apply(this, arguments);
};
function It(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function Q(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, s; n < i; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var Z = function() {
  return Z = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var s in r) Object.prototype.hasOwnProperty.call(r, s) && (t[s] = r[s]);
    }
    return t;
  }, Z.apply(this, arguments);
};
var m;
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(m || (m = {}));
var d;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(d || (d = {}));
var O;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(O || (O = {}));
function He(e) {
  return e.type === d.literal;
}
function At(e) {
  return e.type === d.argument;
}
function Ke(e) {
  return e.type === d.number;
}
function et(e) {
  return e.type === d.date;
}
function tt(e) {
  return e.type === d.time;
}
function rt(e) {
  return e.type === d.select;
}
function nt(e) {
  return e.type === d.plural;
}
function wt(e) {
  return e.type === d.pound;
}
function it(e) {
  return e.type === d.tag;
}
function st(e) {
  return !!(e && typeof e == "object" && e.type === O.number);
}
function ae(e) {
  return !!(e && typeof e == "object" && e.type === O.dateTime);
}
var ot = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, Lt = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function Ct(e) {
  var t = {};
  return e.replace(Lt, function(r) {
    var n = r.length;
    switch (r[0]) {
      // Era
      case "G":
        t.era = n === 4 ? "long" : n === 5 ? "narrow" : "short";
        break;
      // Year
      case "y":
        t.year = n === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      // Quarter
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      // Month
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][n - 1];
        break;
      // Week
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][n - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      // Weekday
      case "E":
        t.weekday = n === 4 ? "long" : n === 5 ? "narrow" : "short";
        break;
      case "e":
        if (n < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][n - 4];
        break;
      case "c":
        if (n < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][n - 4];
        break;
      // Period
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      // am, pm, noon, midnight
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      // Hour
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      // Minute
      case "m":
        t.minute = ["numeric", "2-digit"][n - 1];
        break;
      // Second
      case "s":
        t.second = ["numeric", "2-digit"][n - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      // Zone
      case "z":
        t.timeZoneName = n < 4 ? "short" : "long";
        break;
      case "Z":
      // 1..3, 4, 5: The ISO8601 varios formats
      case "O":
      // 1, 4: milliseconds in day short, long
      case "v":
      // 1, 4: generic non-location format
      case "V":
      // 1, 2, 3, 4: time zone ID or city
      case "X":
      // 1, 2, 3, 4: The ISO8601 varios formats
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
var b = function() {
  return b = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var s in r) Object.prototype.hasOwnProperty.call(r, s) && (t[s] = r[s]);
    }
    return t;
  }, b.apply(this, arguments);
};
var Rt = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function Ot(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var t = e.split(Rt).filter(function(f) {
    return f.length > 0;
  }), r = [], n = 0, i = t; n < i.length; n++) {
    var s = i[n], o = s.split("/");
    if (o.length === 0)
      throw new Error("Invalid number skeleton");
    for (var a = o[0], u = o.slice(1), h = 0, l = u; h < l.length; h++) {
      var p = l[h];
      if (p.length === 0)
        throw new Error("Invalid number skeleton");
    }
    r.push({ stem: a, options: u });
  }
  return r;
}
function Mt(e) {
  return e.replace(/^(.*?)-/, "");
}
var Te = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, at = /^(@+)?(\+|#+)?[rs]?$/g, Ut = /(\*)(0+)|(#+)(0+)|(0+)/g, ht = /^(0+)$/;
function Be(e) {
  var t = {};
  return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(at, function(r, n, i) {
    return typeof i != "string" ? (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length) : i === "+" ? t.minimumSignificantDigits = n.length : n[0] === "#" ? t.maximumSignificantDigits = n.length : (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length + (typeof i == "string" ? i.length : 0)), "";
  }), t;
}
function ut(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function Gt(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (t = {
    notation: "scientific"
  }, e = e.slice(1)), t) {
    var r = e.slice(0, 2);
    if (r === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : r === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !ht.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function Se(e) {
  var t = {}, r = ut(e);
  return r || t;
}
function Dt(e) {
  for (var t = {}, r = 0, n = e; r < n.length; r++) {
    var i = n[r];
    switch (i.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = i.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = Mt(i.options[0]);
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = b(b(b({}, t), { notation: "scientific" }), i.options.reduce(function(u, h) {
          return b(b({}, u), Se(h));
        }, {}));
        continue;
      case "engineering":
        t = b(b(b({}, t), { notation: "engineering" }), i.options.reduce(function(u, h) {
          return b(b({}, u), Se(h));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(i.options[0]);
        continue;
      case "rounding-mode-floor":
        t.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        t.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        t.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        t.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        t.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        t.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        t.roundingMode = "halfExpand";
        continue;
      // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
      case "integer-width":
        if (i.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        i.options[0].replace(Ut, function(u, h, l, p, f, x) {
          if (h)
            t.minimumIntegerDigits = l.length;
          else {
            if (p && f)
              throw new Error("We currently do not support maximum integer digits");
            if (x)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (ht.test(i.stem)) {
      t.minimumIntegerDigits = i.stem.length;
      continue;
    }
    if (Te.test(i.stem)) {
      if (i.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      i.stem.replace(Te, function(u, h, l, p, f, x) {
        return l === "*" ? t.minimumFractionDigits = h.length : p && p[0] === "#" ? t.maximumFractionDigits = p.length : f && x ? (t.minimumFractionDigits = f.length, t.maximumFractionDigits = f.length + x.length) : (t.minimumFractionDigits = h.length, t.maximumFractionDigits = h.length), "";
      });
      var s = i.options[0];
      s === "w" ? t = b(b({}, t), { trailingZeroDisplay: "stripIfInteger" }) : s && (t = b(b({}, t), Be(s)));
      continue;
    }
    if (at.test(i.stem)) {
      t = b(b({}, t), Be(i.stem));
      continue;
    }
    var o = ut(i.stem);
    o && (t = b(b({}, t), o));
    var a = Gt(i.stem);
    a && (t = b(b({}, t), a));
  }
  return t;
}
var F = {
  "001": [
    "H",
    "h"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AD: [
    "H",
    "hB"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  AS: [
    "h",
    "H"
  ],
  AT: [
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  AX: [
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BI: [
    "H",
    "h"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  BO: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  BQ: [
    "H"
  ],
  BR: [
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BT: [
    "h",
    "H"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BY: [
    "H",
    "h"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CD: [
    "hB",
    "H"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  CI: [
    "H",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CL: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CP: [
    "H"
  ],
  CR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CU: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CV: [
    "H",
    "hB"
  ],
  CW: [
    "H",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CZ: [
    "H"
  ],
  DE: [
    "H",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DJ: [
    "h",
    "H"
  ],
  DK: [
    "H"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EC: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  EE: [
    "H",
    "hB"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  FI: [
    "H"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FO: [
    "H",
    "h"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  GF: [
    "H",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GH: [
    "h",
    "H"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GL: [
    "H",
    "h"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GT: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HN: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  HR: [
    "H",
    "hB"
  ],
  HU: [
    "H",
    "h"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  ID: [
    "H"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IN: [
    "h",
    "H"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  IS: [
    "H"
  ],
  IT: [
    "H",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JP: [
    "H",
    "K",
    "h"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LS: [
    "h",
    "H"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  MF: [
    "H",
    "hB"
  ],
  MG: [
    "H",
    "h"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ML: [
    "H"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MT: [
    "H",
    "h"
  ],
  MU: [
    "H",
    "h"
  ],
  MV: [
    "H",
    "h"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MX: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NC: [
    "H",
    "hB"
  ],
  NE: [
    "H"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NI: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  NL: [
    "H",
    "hB"
  ],
  NO: [
    "H",
    "h"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PE: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  PG: [
    "h",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  PL: [
    "H",
    "h"
  ],
  PM: [
    "H",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PT: [
    "H",
    "hB"
  ],
  PW: [
    "h",
    "H"
  ],
  PY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  RU: [
    "H"
  ],
  RW: [
    "H",
    "h"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SE: [
    "H"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  SO: [
    "h",
    "H"
  ],
  SR: [
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  SV: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TH: [
    "H",
    "h"
  ],
  TJ: [
    "H",
    "h"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TM: [
    "H",
    "h"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  TR: [
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VN: [
    "H",
    "h"
  ],
  VU: [
    "h",
    "H"
  ],
  WF: [
    "H",
    "hB"
  ],
  WS: [
    "h",
    "H"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YT: [
    "H",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ZW: [
    "H",
    "h"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BO": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-EC": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-PE": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function Ft(e, t) {
  for (var r = "", n = 0; n < e.length; n++) {
    var i = e.charAt(n);
    if (i === "j") {
      for (var s = 0; n + 1 < e.length && e.charAt(n + 1) === i; )
        s++, n++;
      var o = 1 + (s & 1), a = s < 2 ? 1 : 3 + (s >> 1), u = "a", h = Vt(t);
      for ((h == "H" || h == "k") && (a = 0); a-- > 0; )
        r += u;
      for (; o-- > 0; )
        r = h + r;
    } else i === "J" ? r += "H" : r += i;
  }
  return r;
}
function Vt(e) {
  var t = e.hourCycle;
  if (t === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles && // @ts-ignore
  e.hourCycles.length && (t = e.hourCycles[0]), t)
    switch (t) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var r = e.language, n;
  r !== "root" && (n = e.maximize().region);
  var i = F[n || ""] || F[r || ""] || F["".concat(r, "-001")] || F["001"];
  return i[0];
}
var Y, kt = new RegExp("^".concat(ot.source, "*")), Xt = new RegExp("".concat(ot.source, "*$"));
function g(e, t) {
  return { start: e, end: t };
}
var jt = !!String.prototype.startsWith && "_a".startsWith("a", 1), Wt = !!String.fromCodePoint, $t = !!Object.fromEntries, Zt = !!String.prototype.codePointAt, zt = !!String.prototype.trimStart, Jt = !!String.prototype.trimEnd, Qt = !!Number.isSafeInteger, Yt = Qt ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, he = !0;
try {
  var qt = ft("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  he = ((Y = qt.exec("a")) === null || Y === void 0 ? void 0 : Y[0]) === "a";
} catch {
  he = !1;
}
var Ne = jt ? (
  // Native
  function(t, r, n) {
    return t.startsWith(r, n);
  }
) : (
  // For IE11
  function(t, r, n) {
    return t.slice(n, n + r.length) === r;
  }
), ue = Wt ? String.fromCodePoint : (
  // IE11
  function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    for (var n = "", i = t.length, s = 0, o; i > s; ) {
      if (o = t[s++], o > 1114111)
        throw RangeError(o + " is not a valid code point");
      n += o < 65536 ? String.fromCharCode(o) : String.fromCharCode(((o -= 65536) >> 10) + 55296, o % 1024 + 56320);
    }
    return n;
  }
), Pe = (
  // native
  $t ? Object.fromEntries : (
    // Ponyfill
    function(t) {
      for (var r = {}, n = 0, i = t; n < i.length; n++) {
        var s = i[n], o = s[0], a = s[1];
        r[o] = a;
      }
      return r;
    }
  )
), lt = Zt ? (
  // Native
  function(t, r) {
    return t.codePointAt(r);
  }
) : (
  // IE 11
  function(t, r) {
    var n = t.length;
    if (!(r < 0 || r >= n)) {
      var i = t.charCodeAt(r), s;
      return i < 55296 || i > 56319 || r + 1 === n || (s = t.charCodeAt(r + 1)) < 56320 || s > 57343 ? i : (i - 55296 << 10) + (s - 56320) + 65536;
    }
  }
), Kt = zt ? (
  // Native
  function(t) {
    return t.trimStart();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(kt, "");
  }
), er = Jt ? (
  // Native
  function(t) {
    return t.trimEnd();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(Xt, "");
  }
);
function ft(e, t) {
  return new RegExp(e, t);
}
var le;
if (he) {
  var Ie = ft("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  le = function(t, r) {
    var n;
    Ie.lastIndex = r;
    var i = Ie.exec(t);
    return (n = i[1]) !== null && n !== void 0 ? n : "";
  };
} else
  le = function(t, r) {
    for (var n = []; ; ) {
      var i = lt(t, r);
      if (i === void 0 || ct(i) || ir(i))
        break;
      n.push(i), r += i >= 65536 ? 2 : 1;
    }
    return ue.apply(void 0, n);
  };
var tr = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!r.ignoreTag, this.locale = r.locale, this.requiresOtherClause = !!r.requiresOtherClause, this.shouldParseSkeletons = !!r.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(t, r, n) {
      for (var i = []; !this.isEOF(); ) {
        var s = this.char();
        if (s === 123) {
          var o = this.parseArgument(t, n);
          if (o.err)
            return o;
          i.push(o.val);
        } else {
          if (s === 125 && t > 0)
            break;
          if (s === 35 && (r === "plural" || r === "selectordinal")) {
            var a = this.clonePosition();
            this.bump(), i.push({
              type: d.pound,
              location: g(a, this.clonePosition())
            });
          } else if (s === 60 && !this.ignoreTag && this.peek() === 47) {
            if (n)
              break;
            return this.error(m.UNMATCHED_CLOSING_TAG, g(this.clonePosition(), this.clonePosition()));
          } else if (s === 60 && !this.ignoreTag && fe(this.peek() || 0)) {
            var o = this.parseTag(t, r);
            if (o.err)
              return o;
            i.push(o.val);
          } else {
            var o = this.parseLiteral(t, r);
            if (o.err)
              return o;
            i.push(o.val);
          }
        }
      }
      return { val: i, err: null };
    }, e.prototype.parseTag = function(t, r) {
      var n = this.clonePosition();
      this.bump();
      var i = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: d.literal,
            value: "<".concat(i, "/>"),
            location: g(n, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var s = this.parseMessage(t + 1, r, !0);
        if (s.err)
          return s;
        var o = s.val, a = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !fe(this.char()))
            return this.error(m.INVALID_TAG, g(a, this.clonePosition()));
          var u = this.clonePosition(), h = this.parseTagName();
          return i !== h ? this.error(m.UNMATCHED_CLOSING_TAG, g(u, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: d.tag,
              value: i,
              children: o,
              location: g(n, this.clonePosition())
            },
            err: null
          } : this.error(m.INVALID_TAG, g(a, this.clonePosition())));
        } else
          return this.error(m.UNCLOSED_TAG, g(n, this.clonePosition()));
      } else
        return this.error(m.INVALID_TAG, g(n, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && nr(this.char()); )
        this.bump();
      return this.message.slice(t, this.offset());
    }, e.prototype.parseLiteral = function(t, r) {
      for (var n = this.clonePosition(), i = ""; ; ) {
        var s = this.tryParseQuote(r);
        if (s) {
          i += s;
          continue;
        }
        var o = this.tryParseUnquoted(t, r);
        if (o) {
          i += o;
          continue;
        }
        var a = this.tryParseLeftAngleBracket();
        if (a) {
          i += a;
          continue;
        }
        break;
      }
      var u = g(n, this.clonePosition());
      return {
        val: { type: d.literal, value: i, location: u },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !rr(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(t) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        // '{', '<', '>', '}'
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === "plural" || t === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var r = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var n = this.char();
        if (n === 39)
          if (this.peek() === 39)
            r.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          r.push(n);
        this.bump();
      }
      return ue.apply(void 0, r);
    }, e.prototype.tryParseUnquoted = function(t, r) {
      if (this.isEOF())
        return null;
      var n = this.char();
      return n === 60 || n === 123 || n === 35 && (r === "plural" || r === "selectordinal") || n === 125 && t > 0 ? null : (this.bump(), ue(n));
    }, e.prototype.parseArgument = function(t, r) {
      var n = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(m.EXPECT_ARGUMENT_CLOSING_BRACE, g(n, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(m.EMPTY_ARGUMENT, g(n, this.clonePosition()));
      var i = this.parseIdentifierIfPossible().value;
      if (!i)
        return this.error(m.MALFORMED_ARGUMENT, g(n, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(m.EXPECT_ARGUMENT_CLOSING_BRACE, g(n, this.clonePosition()));
      switch (this.char()) {
        // Simple argument: `{name}`
        case 125:
          return this.bump(), {
            val: {
              type: d.argument,
              // value does not include the opening and closing braces.
              value: i,
              location: g(n, this.clonePosition())
            },
            err: null
          };
        // Argument with options: `{name, format, ...}`
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(m.EXPECT_ARGUMENT_CLOSING_BRACE, g(n, this.clonePosition())) : this.parseArgumentOptions(t, r, i, n);
        default:
          return this.error(m.MALFORMED_ARGUMENT, g(n, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var t = this.clonePosition(), r = this.offset(), n = le(this.message, r), i = r + n.length;
      this.bumpTo(i);
      var s = this.clonePosition(), o = g(t, s);
      return { value: n, location: o };
    }, e.prototype.parseArgumentOptions = function(t, r, n, i) {
      var s, o = this.clonePosition(), a = this.parseIdentifierIfPossible().value, u = this.clonePosition();
      switch (a) {
        case "":
          return this.error(m.EXPECT_ARGUMENT_TYPE, g(o, u));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var h = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var l = this.clonePosition(), p = this.parseSimpleArgStyleIfPossible();
            if (p.err)
              return p;
            var f = er(p.val);
            if (f.length === 0)
              return this.error(m.EXPECT_ARGUMENT_STYLE, g(this.clonePosition(), this.clonePosition()));
            var x = g(l, this.clonePosition());
            h = { style: f, styleLocation: x };
          }
          var _ = this.tryParseArgumentClose(i);
          if (_.err)
            return _;
          var v = g(i, this.clonePosition());
          if (h && Ne(h == null ? void 0 : h.style, "::", 0)) {
            var N = Kt(h.style.slice(2));
            if (a === "number") {
              var p = this.parseNumberSkeletonFromString(N, h.styleLocation);
              return p.err ? p : {
                val: { type: d.number, value: n, location: v, style: p.val },
                err: null
              };
            } else {
              if (N.length === 0)
                return this.error(m.EXPECT_DATE_TIME_SKELETON, v);
              var T = N;
              this.locale && (T = Ft(N, this.locale));
              var f = {
                type: O.dateTime,
                pattern: T,
                location: h.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? Ct(T) : {}
              }, I = a === "date" ? d.date : d.time;
              return {
                val: { type: I, value: n, location: v, style: f },
                err: null
              };
            }
          }
          return {
            val: {
              type: a === "number" ? d.number : a === "date" ? d.date : d.time,
              value: n,
              location: v,
              style: (s = h == null ? void 0 : h.style) !== null && s !== void 0 ? s : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var H = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(m.EXPECT_SELECT_ARGUMENT_OPTIONS, g(H, Z({}, H)));
          this.bumpSpace();
          var C = this.parseIdentifierIfPossible(), A = 0;
          if (a !== "select" && C.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(m.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, g(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var p = this.tryParseDecimalInteger(m.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, m.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (p.err)
              return p;
            this.bumpSpace(), C = this.parseIdentifierIfPossible(), A = p.val;
          }
          var U = this.tryParsePluralOrSelectOptions(t, a, r, C);
          if (U.err)
            return U;
          var _ = this.tryParseArgumentClose(i);
          if (_.err)
            return _;
          var R = g(i, this.clonePosition());
          return a === "select" ? {
            val: {
              type: d.select,
              value: n,
              options: Pe(U.val),
              location: R
            },
            err: null
          } : {
            val: {
              type: d.plural,
              value: n,
              options: Pe(U.val),
              offset: A,
              pluralType: a === "plural" ? "cardinal" : "ordinal",
              location: R
            },
            err: null
          };
        }
        default:
          return this.error(m.INVALID_ARGUMENT_TYPE, g(o, u));
      }
    }, e.prototype.tryParseArgumentClose = function(t) {
      return this.isEOF() || this.char() !== 125 ? this.error(m.EXPECT_ARGUMENT_CLOSING_BRACE, g(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var t = 0, r = this.clonePosition(); !this.isEOF(); ) {
        var n = this.char();
        switch (n) {
          case 39: {
            this.bump();
            var i = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(m.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, g(i, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            t += 1, this.bump();
            break;
          }
          case 125: {
            if (t > 0)
              t -= 1;
            else
              return {
                val: this.message.slice(r.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(r.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(t, r) {
      var n = [];
      try {
        n = Ot(t);
      } catch {
        return this.error(m.INVALID_NUMBER_SKELETON, r);
      }
      return {
        val: {
          type: O.number,
          tokens: n,
          location: r,
          parsedOptions: this.shouldParseSkeletons ? Dt(n) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(t, r, n, i) {
      for (var s, o = !1, a = [], u = /* @__PURE__ */ new Set(), h = i.value, l = i.location; ; ) {
        if (h.length === 0) {
          var p = this.clonePosition();
          if (r !== "select" && this.bumpIf("=")) {
            var f = this.tryParseDecimalInteger(m.EXPECT_PLURAL_ARGUMENT_SELECTOR, m.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (f.err)
              return f;
            l = g(p, this.clonePosition()), h = this.message.slice(p.offset, this.offset());
          } else
            break;
        }
        if (u.has(h))
          return this.error(r === "select" ? m.DUPLICATE_SELECT_ARGUMENT_SELECTOR : m.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, l);
        h === "other" && (o = !0), this.bumpSpace();
        var x = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(r === "select" ? m.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : m.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, g(this.clonePosition(), this.clonePosition()));
        var _ = this.parseMessage(t + 1, r, n);
        if (_.err)
          return _;
        var v = this.tryParseArgumentClose(x);
        if (v.err)
          return v;
        a.push([
          h,
          {
            value: _.val,
            location: g(x, this.clonePosition())
          }
        ]), u.add(h), this.bumpSpace(), s = this.parseIdentifierIfPossible(), h = s.value, l = s.location;
      }
      return a.length === 0 ? this.error(r === "select" ? m.EXPECT_SELECT_ARGUMENT_SELECTOR : m.EXPECT_PLURAL_ARGUMENT_SELECTOR, g(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !o ? this.error(m.MISSING_OTHER_CLAUSE, g(this.clonePosition(), this.clonePosition())) : { val: a, err: null };
    }, e.prototype.tryParseDecimalInteger = function(t, r) {
      var n = 1, i = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (n = -1);
      for (var s = !1, o = 0; !this.isEOF(); ) {
        var a = this.char();
        if (a >= 48 && a <= 57)
          s = !0, o = o * 10 + (a - 48), this.bump();
        else
          break;
      }
      var u = g(i, this.clonePosition());
      return s ? (o *= n, Yt(o) ? { val: o, err: null } : this.error(r, u)) : this.error(t, u);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var t = this.position.offset;
      if (t >= this.message.length)
        throw Error("out of bound");
      var r = lt(this.message, t);
      if (r === void 0)
        throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      return r;
    }, e.prototype.error = function(t, r) {
      return {
        val: null,
        err: {
          kind: t,
          message: this.message,
          location: r
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(t) {
      if (Ne(this.message, t, this.offset())) {
        for (var r = 0; r < t.length; r++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(t) {
      var r = this.offset(), n = this.message.indexOf(t, r);
      return n >= 0 ? (this.bumpTo(n), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(t) {
      if (this.offset() > t)
        throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (t = Math.min(t, this.message.length); ; ) {
        var r = this.offset();
        if (r === t)
          break;
        if (r > t)
          throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && ct(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var t = this.char(), r = this.offset(), n = this.message.charCodeAt(r + (t >= 65536 ? 2 : 1));
      return n ?? null;
    }, e;
  })()
);
function fe(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function rr(e) {
  return fe(e) || e === 47;
}
function nr(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function ct(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function ir(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function ce(e) {
  e.forEach(function(t) {
    if (delete t.location, rt(t) || nt(t))
      for (var r in t.options)
        delete t.options[r].location, ce(t.options[r].value);
    else Ke(t) && st(t.style) || (et(t) || tt(t)) && ae(t.style) ? delete t.style.location : it(t) && ce(t.children);
  });
}
function sr(e, t) {
  t === void 0 && (t = {}), t = Z({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t);
  var r = new tr(e, t).parse();
  if (r.err) {
    var n = SyntaxError(m[r.err.kind]);
    throw n.location = r.err.location, n.originalMessage = r.err.message, n;
  }
  return t != null && t.captureLocation || ce(r.val), r.val;
}
function q(e, t) {
  var r = t && t.cache ? t.cache : fr, n = t && t.serializer ? t.serializer : lr, i = t && t.strategy ? t.strategy : hr;
  return i(e, {
    cache: r,
    serializer: n
  });
}
function or(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function ar(e, t, r, n) {
  var i = or(n) ? n : r(n), s = t.get(i);
  return typeof s > "u" && (s = e.call(this, n), t.set(i, s)), s;
}
function pt(e, t, r) {
  var n = Array.prototype.slice.call(arguments, 3), i = r(n), s = t.get(i);
  return typeof s > "u" && (s = e.apply(this, n), t.set(i, s)), s;
}
function mt(e, t, r, n, i) {
  return r.bind(t, e, n, i);
}
function hr(e, t) {
  var r = e.length === 1 ? ar : pt;
  return mt(e, this, r, t.cache.create(), t.serializer);
}
function ur(e, t) {
  return mt(e, this, pt, t.cache.create(), t.serializer);
}
var lr = function() {
  return JSON.stringify(arguments);
};
function de() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
de.prototype.get = function(e) {
  return this.cache[e];
};
de.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var fr = {
  create: function() {
    return new de();
  }
}, K = {
  variadic: ur
}, M;
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(M || (M = {}));
var J = (
  /** @class */
  (function(e) {
    z(t, e);
    function t(r, n, i) {
      var s = e.call(this, r) || this;
      return s.code = n, s.originalMessage = i, s;
    }
    return t.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  })(Error)
), Ae = (
  /** @class */
  (function(e) {
    z(t, e);
    function t(r, n, i, s) {
      return e.call(this, 'Invalid values for "'.concat(r, '": "').concat(n, '". Options are "').concat(Object.keys(i).join('", "'), '"'), M.INVALID_VALUE, s) || this;
    }
    return t;
  })(J)
), cr = (
  /** @class */
  (function(e) {
    z(t, e);
    function t(r, n, i) {
      return e.call(this, 'Value for "'.concat(r, '" must be of type ').concat(n), M.INVALID_VALUE, i) || this;
    }
    return t;
  })(J)
), pr = (
  /** @class */
  (function(e) {
    z(t, e);
    function t(r, n) {
      return e.call(this, 'The intl string context variable "'.concat(r, '" was not provided to the string "').concat(n, '"'), M.MISSING_VALUE, n) || this;
    }
    return t;
  })(J)
), y;
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(y || (y = {}));
function mr(e) {
  return e.length < 2 ? e : e.reduce(function(t, r) {
    var n = t[t.length - 1];
    return !n || n.type !== y.literal || r.type !== y.literal ? t.push(r) : n.value += r.value, t;
  }, []);
}
function gr(e) {
  return typeof e == "function";
}
function j(e, t, r, n, i, s, o) {
  if (e.length === 1 && He(e[0]))
    return [
      {
        type: y.literal,
        value: e[0].value
      }
    ];
  for (var a = [], u = 0, h = e; u < h.length; u++) {
    var l = h[u];
    if (He(l)) {
      a.push({
        type: y.literal,
        value: l.value
      });
      continue;
    }
    if (wt(l)) {
      typeof s == "number" && a.push({
        type: y.literal,
        value: r.getNumberFormat(t).format(s)
      });
      continue;
    }
    var p = l.value;
    if (!(i && p in i))
      throw new pr(p, o);
    var f = i[p];
    if (At(l)) {
      (!f || typeof f == "string" || typeof f == "number") && (f = typeof f == "string" || typeof f == "number" ? String(f) : ""), a.push({
        type: typeof f == "string" ? y.literal : y.object,
        value: f
      });
      continue;
    }
    if (et(l)) {
      var x = typeof l.style == "string" ? n.date[l.style] : ae(l.style) ? l.style.parsedOptions : void 0;
      a.push({
        type: y.literal,
        value: r.getDateTimeFormat(t, x).format(f)
      });
      continue;
    }
    if (tt(l)) {
      var x = typeof l.style == "string" ? n.time[l.style] : ae(l.style) ? l.style.parsedOptions : n.time.medium;
      a.push({
        type: y.literal,
        value: r.getDateTimeFormat(t, x).format(f)
      });
      continue;
    }
    if (Ke(l)) {
      var x = typeof l.style == "string" ? n.number[l.style] : st(l.style) ? l.style.parsedOptions : void 0;
      x && x.scale && (f = f * (x.scale || 1)), a.push({
        type: y.literal,
        value: r.getNumberFormat(t, x).format(f)
      });
      continue;
    }
    if (it(l)) {
      var _ = l.children, v = l.value, N = i[v];
      if (!gr(N))
        throw new cr(v, "function", o);
      var T = j(_, t, r, n, i, s), I = N(T.map(function(A) {
        return A.value;
      }));
      Array.isArray(I) || (I = [I]), a.push.apply(a, I.map(function(A) {
        return {
          type: typeof A == "string" ? y.literal : y.object,
          value: A
        };
      }));
    }
    if (rt(l)) {
      var H = l.options[f] || l.options.other;
      if (!H)
        throw new Ae(l.value, f, Object.keys(l.options), o);
      a.push.apply(a, j(H.value, t, r, n, i));
      continue;
    }
    if (nt(l)) {
      var H = l.options["=".concat(f)];
      if (!H) {
        if (!Intl.PluralRules)
          throw new J(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, M.MISSING_INTL_API, o);
        var C = r.getPluralRules(t, { type: l.pluralType }).select(f - (l.offset || 0));
        H = l.options[C] || l.options.other;
      }
      if (!H)
        throw new Ae(l.value, f, Object.keys(l.options), o);
      a.push.apply(a, j(H.value, t, r, n, i, f - (l.offset || 0)));
      continue;
    }
  }
  return mr(a);
}
function dr(e, t) {
  return t ? P(P(P({}, e || {}), t || {}), Object.keys(e).reduce(function(r, n) {
    return r[n] = P(P({}, e[n]), t[n] || {}), r;
  }, {})) : e;
}
function br(e, t) {
  return t ? Object.keys(e).reduce(function(r, n) {
    return r[n] = dr(e[n], t[n]), r;
  }, P({}, e)) : e;
}
function ee(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, r) {
          e[t] = r;
        }
      };
    }
  };
}
function xr(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: q(function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return new ((t = Intl.NumberFormat).bind.apply(t, Q([void 0], r, !1)))();
    }, {
      cache: ee(e.number),
      strategy: K.variadic
    }),
    getDateTimeFormat: q(function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return new ((t = Intl.DateTimeFormat).bind.apply(t, Q([void 0], r, !1)))();
    }, {
      cache: ee(e.dateTime),
      strategy: K.variadic
    }),
    getPluralRules: q(function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return new ((t = Intl.PluralRules).bind.apply(t, Q([void 0], r, !1)))();
    }, {
      cache: ee(e.pluralRules),
      strategy: K.variadic
    })
  };
}
var Er = (
  /** @class */
  (function() {
    function e(t, r, n, i) {
      var s = this;
      if (r === void 0 && (r = e.defaultLocale), this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function(u) {
        var h = s.formatToParts(u);
        if (h.length === 1)
          return h[0].value;
        var l = h.reduce(function(p, f) {
          return !p.length || f.type !== y.literal || typeof p[p.length - 1] != "string" ? p.push(f.value) : p[p.length - 1] += f.value, p;
        }, []);
        return l.length <= 1 ? l[0] || "" : l;
      }, this.formatToParts = function(u) {
        return j(s.ast, s.locales, s.formatters, s.formats, u, void 0, s.message);
      }, this.resolvedOptions = function() {
        var u;
        return {
          locale: ((u = s.resolvedLocale) === null || u === void 0 ? void 0 : u.toString()) || Intl.NumberFormat.supportedLocalesOf(s.locales)[0]
        };
      }, this.getAst = function() {
        return s.ast;
      }, this.locales = r, this.resolvedLocale = e.resolveLocale(r), typeof t == "string") {
        if (this.message = t, !e.__parse)
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        var o = i || {};
        o.formatters;
        var a = It(o, ["formatters"]);
        this.ast = e.__parse(t, P(P({}, a), { locale: this.resolvedLocale }));
      } else
        this.ast = t;
      if (!Array.isArray(this.ast))
        throw new TypeError("A message must be provided as a String or AST.");
      this.formats = br(e.formats, n), this.formatters = i && i.formatters || xr(this.formatterCache);
    }
    return Object.defineProperty(e, "defaultLocale", {
      get: function() {
        return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), e.memoizedDefaultLocale = null, e.resolveLocale = function(t) {
      if (!(typeof Intl.Locale > "u")) {
        var r = Intl.NumberFormat.supportedLocalesOf(t);
        return r.length > 0 ? new Intl.Locale(r[0]) : new Intl.Locale(typeof t == "string" ? t : t[0]);
      }
    }, e.__parse = sr, e.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, e;
  })()
);
const gt = (e, t, r) => (n, i) => {
  if (n === void 0) return "";
  const s = t(n);
  if (r && (n = r(n)), !s)
    return console.warn(
      `Can't find namespace. Make sure you pass all used namespaces in the getBaseServerSideProps. Some troubles with "${n}"`
    ), "";
  for (let o of s) {
    const a = e(n, { ns: o, ...i });
    if (a && a !== n) return a;
  }
  return n;
}, vr = (e, t, r) => (n, i, s) => {
  const o = gt(e, t, r);
  try {
    const a = o(n, s);
    if (!a) return "";
    const h = new Er(a).format(i);
    return Array.isArray(h) ? h.join("") : h;
  } catch (a) {
    return console.error(`tICU formatting error for key "${n}":`, a), "";
  }
}, Fr = ({
  useTranslation: e,
  defaultNamespaces: t,
  namespaceMapper: r,
  assetKeyMapper: n
}) => function(s = []) {
  const { t: o, ...a } = e([...t, ...s]), u = ie(gt(o, r, n), [o]), h = ie(vr(o, r, n), [
    o
  ]);
  return { t: u, tICU: h, ...a };
}, Vr = (e) => {
  try {
    const t = new URL(e);
    return t.protocol === "http:" || t.protocol === "https:";
  } catch {
    return !1;
  }
};
function kr(e) {
  return /(?:^|\.)systeme\.(?:io|club|local)$/i.test(e);
}
const Xr = (e, t, r = 2) => {
  if (t === 0)
    return we(0);
  const n = e / t * 100;
  return we(parseFloat(n.toFixed(r)));
}, we = (e) => e;
function jr() {
  if (typeof Node == "function" && Node.prototype) {
    const e = Node.prototype.removeChild;
    Node.prototype.removeChild = function(r) {
      return r.parentNode !== this ? (console && console.error("Cannot remove a child from a different parent", r, this), r) : e.apply(this, arguments);
    };
    const t = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function(r, n) {
      return n && n.parentNode !== this ? (console && console.error(
        "Cannot insert before a reference node from a different parent",
        n,
        this
      ), r) : t.apply(this, arguments);
    };
  }
}
const Wr = (e) => e.replace(/^www\./, ""), $r = (e, t) => {
  Ve(() => {
    t(e);
  }, [e]);
};
function W() {
  return typeof window < "u" && typeof document < "u";
}
const Zr = (e, t = {
  parser: (r) => JSON.parse(r),
  stringifier: (r) => JSON.stringify(r)
}) => ({
  setItem: (s) => {
    W() && localStorage.setItem(e, t.stringifier(s));
  },
  getItem: () => {
    if (W()) {
      const s = localStorage.getItem(e);
      return s ? t.parser(s) : null;
    }
    return null;
  },
  removeItem: () => {
    W() && localStorage.removeItem(e);
  }
});
var yr = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, L = function(e) {
  return typeof e == "string" ? e.length > 0 : typeof e == "number";
}, E = function(e, t, r) {
  return t === void 0 && (t = 0), r === void 0 && (r = Math.pow(10, t)), Math.round(r * e) / r + 0;
}, S = function(e, t, r) {
  return t === void 0 && (t = 0), r === void 0 && (r = 1), e > r ? r : e > t ? e : t;
}, dt = function(e) {
  return (e = isFinite(e) ? e % 360 : 0) > 0 ? e : e + 360;
}, Le = function(e) {
  return { r: S(e.r, 0, 255), g: S(e.g, 0, 255), b: S(e.b, 0, 255), a: S(e.a) };
}, te = function(e) {
  return { r: E(e.r), g: E(e.g), b: E(e.b), a: E(e.a, 3) };
}, _r = /^#([0-9a-f]{3,8})$/i, V = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, bt = function(e) {
  var t = e.r, r = e.g, n = e.b, i = e.a, s = Math.max(t, r, n), o = s - Math.min(t, r, n), a = o ? s === t ? (r - n) / o : s === r ? 2 + (n - t) / o : 4 + (t - r) / o : 0;
  return { h: 60 * (a < 0 ? a + 6 : a), s: s ? o / s * 100 : 0, v: s / 255 * 100, a: i };
}, xt = function(e) {
  var t = e.h, r = e.s, n = e.v, i = e.a;
  t = t / 360 * 6, r /= 100, n /= 100;
  var s = Math.floor(t), o = n * (1 - r), a = n * (1 - (t - s) * r), u = n * (1 - (1 - t + s) * r), h = s % 6;
  return { r: 255 * [n, a, o, o, u, n][h], g: 255 * [u, n, n, a, o, o][h], b: 255 * [o, o, u, n, n, a][h], a: i };
}, Ce = function(e) {
  return { h: dt(e.h), s: S(e.s, 0, 100), l: S(e.l, 0, 100), a: S(e.a) };
}, Re = function(e) {
  return { h: E(e.h), s: E(e.s), l: E(e.l), a: E(e.a, 3) };
}, Oe = function(e) {
  return xt((r = (t = e).s, { h: t.h, s: (r *= ((n = t.l) < 50 ? n : 100 - n) / 100) > 0 ? 2 * r / (n + r) * 100 : 0, v: n + r, a: t.a }));
  var t, r, n;
}, D = function(e) {
  return { h: (t = bt(e)).h, s: (i = (200 - (r = t.s)) * (n = t.v) / 100) > 0 && i < 200 ? r * n / 100 / (i <= 100 ? i : 200 - i) * 100 : 0, l: i / 2, a: t.a };
  var t, r, n, i;
}, Hr = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Tr = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Br = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Sr = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Me = { string: [[function(e) {
  var t = _r.exec(e);
  return t ? (e = t[1]).length <= 4 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? E(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : e.length === 6 || e.length === 8 ? { r: parseInt(e.substr(0, 2), 16), g: parseInt(e.substr(2, 2), 16), b: parseInt(e.substr(4, 2), 16), a: e.length === 8 ? E(parseInt(e.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(e) {
  var t = Br.exec(e) || Sr.exec(e);
  return t ? t[2] !== t[4] || t[4] !== t[6] ? null : Le({ r: Number(t[1]) / (t[2] ? 100 / 255 : 1), g: Number(t[3]) / (t[4] ? 100 / 255 : 1), b: Number(t[5]) / (t[6] ? 100 / 255 : 1), a: t[7] === void 0 ? 1 : Number(t[7]) / (t[8] ? 100 : 1) }) : null;
}, "rgb"], [function(e) {
  var t = Hr.exec(e) || Tr.exec(e);
  if (!t) return null;
  var r, n, i = Ce({ h: (r = t[1], n = t[2], n === void 0 && (n = "deg"), Number(r) * (yr[n] || 1)), s: Number(t[3]), l: Number(t[4]), a: t[5] === void 0 ? 1 : Number(t[5]) / (t[6] ? 100 : 1) });
  return Oe(i);
}, "hsl"]], object: [[function(e) {
  var t = e.r, r = e.g, n = e.b, i = e.a, s = i === void 0 ? 1 : i;
  return L(t) && L(r) && L(n) ? Le({ r: Number(t), g: Number(r), b: Number(n), a: Number(s) }) : null;
}, "rgb"], [function(e) {
  var t = e.h, r = e.s, n = e.l, i = e.a, s = i === void 0 ? 1 : i;
  if (!L(t) || !L(r) || !L(n)) return null;
  var o = Ce({ h: Number(t), s: Number(r), l: Number(n), a: Number(s) });
  return Oe(o);
}, "hsl"], [function(e) {
  var t = e.h, r = e.s, n = e.v, i = e.a, s = i === void 0 ? 1 : i;
  if (!L(t) || !L(r) || !L(n)) return null;
  var o = (function(a) {
    return { h: dt(a.h), s: S(a.s, 0, 100), v: S(a.v, 0, 100), a: S(a.a) };
  })({ h: Number(t), s: Number(r), v: Number(n), a: Number(s) });
  return xt(o);
}, "hsv"]] }, Ue = function(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r][0](e);
    if (n) return [n, t[r][1]];
  }
  return [null, void 0];
}, Nr = function(e) {
  return typeof e == "string" ? Ue(e.trim(), Me.string) : typeof e == "object" && e !== null ? Ue(e, Me.object) : [null, void 0];
}, re = function(e, t) {
  var r = D(e);
  return { h: r.h, s: S(r.s + 100 * t, 0, 100), l: r.l, a: r.a };
}, ne = function(e) {
  return (299 * e.r + 587 * e.g + 114 * e.b) / 1e3 / 255;
}, Ge = function(e, t) {
  var r = D(e);
  return { h: r.h, s: r.s, l: S(r.l + 100 * t, 0, 100), a: r.a };
}, De = (function() {
  function e(t) {
    this.parsed = Nr(t)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return e.prototype.isValid = function() {
    return this.parsed !== null;
  }, e.prototype.brightness = function() {
    return E(ne(this.rgba), 2);
  }, e.prototype.isDark = function() {
    return ne(this.rgba) < 0.5;
  }, e.prototype.isLight = function() {
    return ne(this.rgba) >= 0.5;
  }, e.prototype.toHex = function() {
    return t = te(this.rgba), r = t.r, n = t.g, i = t.b, o = (s = t.a) < 1 ? V(E(255 * s)) : "", "#" + V(r) + V(n) + V(i) + o;
    var t, r, n, i, s, o;
  }, e.prototype.toRgb = function() {
    return te(this.rgba);
  }, e.prototype.toRgbString = function() {
    return t = te(this.rgba), r = t.r, n = t.g, i = t.b, (s = t.a) < 1 ? "rgba(" + r + ", " + n + ", " + i + ", " + s + ")" : "rgb(" + r + ", " + n + ", " + i + ")";
    var t, r, n, i, s;
  }, e.prototype.toHsl = function() {
    return Re(D(this.rgba));
  }, e.prototype.toHslString = function() {
    return t = Re(D(this.rgba)), r = t.h, n = t.s, i = t.l, (s = t.a) < 1 ? "hsla(" + r + ", " + n + "%, " + i + "%, " + s + ")" : "hsl(" + r + ", " + n + "%, " + i + "%)";
    var t, r, n, i, s;
  }, e.prototype.toHsv = function() {
    return t = bt(this.rgba), { h: E(t.h), s: E(t.s), v: E(t.v), a: E(t.a, 3) };
    var t;
  }, e.prototype.invert = function() {
    return B({ r: 255 - (t = this.rgba).r, g: 255 - t.g, b: 255 - t.b, a: t.a });
    var t;
  }, e.prototype.saturate = function(t) {
    return t === void 0 && (t = 0.1), B(re(this.rgba, t));
  }, e.prototype.desaturate = function(t) {
    return t === void 0 && (t = 0.1), B(re(this.rgba, -t));
  }, e.prototype.grayscale = function() {
    return B(re(this.rgba, -1));
  }, e.prototype.lighten = function(t) {
    return t === void 0 && (t = 0.1), B(Ge(this.rgba, t));
  }, e.prototype.darken = function(t) {
    return t === void 0 && (t = 0.1), B(Ge(this.rgba, -t));
  }, e.prototype.rotate = function(t) {
    return t === void 0 && (t = 15), this.hue(this.hue() + t);
  }, e.prototype.alpha = function(t) {
    return typeof t == "number" ? B({ r: (r = this.rgba).r, g: r.g, b: r.b, a: t }) : E(this.rgba.a, 3);
    var r;
  }, e.prototype.hue = function(t) {
    var r = D(this.rgba);
    return typeof t == "number" ? B({ h: t, s: r.s, l: r.l, a: r.a }) : E(r.h);
  }, e.prototype.isEqual = function(t) {
    return this.toHex() === B(t).toHex();
  }, e;
})(), B = function(e) {
  return e instanceof De ? e : new De(e);
};
const k = [
  {
    primaryColor: "--brand-primary",
    colors: [
      { cssVar: "--brand-primary" },
      {
        cssVar: "--brand-primary-hover",
        lightnessMultiplier: 0.86
      },
      {
        cssVar: "--brand-primary-subtle",
        hueDelta: 8,
        saturation: 25,
        lightness: 98
      }
    ]
  },
  {
    primaryColor: "--text-primary",
    colors: [
      { cssVar: "--text-primary" },
      {
        cssVar: "--text-secondary",
        hueDelta: -16,
        saturation: 14,
        lightness: 65
      },
      {
        cssVar: "--text-tertiary",
        hueDelta: -6,
        saturation: 16,
        lightness: 50
      },
      {
        cssVar: "--fill-primary",
        hueDelta: -8,
        saturation: 27,
        lightness: 84
      }
    ]
  },
  {
    primaryColor: "--background-primary",
    colors: [
      { cssVar: "--background-primary" },
      {
        cssVar: "--background-tertiary",
        hueDelta: -4,
        saturation: 16,
        lightness: 93
      },
      {
        cssVar: "--skeleton-primary",
        hueDelta: 19,
        saturation: 8,
        lightness: 81
      }
    ]
  },
  {
    primaryColor: "--background-header",
    colors: [{ cssVar: "--background-header" }]
  }
];
function X(e, t) {
  const r = B(e).toRgb(), n = B(e).toHsl(), i = {};
  return t.colors.forEach((s) => {
    if (s.cssVar === t.primaryColor)
      i[s.cssVar] = `${r.r} ${r.g} ${r.b}`;
    else {
      let o = n.h + (s.hueDelta ?? 0);
      o < 0 && (o += 360), o >= 360 && (o -= 360);
      const a = s.saturation !== void 0 ? Math.round(s.saturation) : n.s, u = s.lightness !== void 0 ? Math.round(s.lightness) : s.lightnessMultiplier ? Math.round(n.l * s.lightnessMultiplier) : n.l, h = B({ h: o, s: a, l: u }).toRgb();
      i[s.cssVar] = `${h.r} ${h.g} ${h.b}`;
    }
  }), i;
}
const zr = (e) => {
  const t = Object.entries(
    X(e.oldBrandPrimary, k[0])
  ).map(([s, o]) => `${s}: ${o};`).join(`
`), r = Object.entries(
    X(e.oldTextPrimary, k[1])
  ).map(([s, o]) => `${s}: ${o};`).join(`
`), n = Object.entries(
    X(e.oldBackgroundPrimary, k[2])
  ).map(([s, o]) => `${s}: ${o};`).join(`
`), i = Object.entries(
    X(e.oldBackgroundHeader, k[3])
  ).map(([s, o]) => `${s}: ${o};`).join(`
`);
  return `
        ${[
    t,
    r,
    n,
    i
  ].join(`

`)}
    `;
}, Pr = "brand_data", Jr = () => {
  if (!W()) return;
  const e = localStorage.getItem(Pr);
  if (e)
    try {
      return JSON.parse(e);
    } catch {
      return;
    }
};
var pe = /* @__PURE__ */ ((e) => (e.Editor = "editor", e.Community = "community", e.BlockPreview = "block_preview", e.Membership = "membership", e.Marketplace = "marketplace", e.Settings = "settings", e.Email = "email", e.Ckeditor = "ckeditor", e.TextEditor = "text_editor", e.BlogPost = "blog_post", e.PageTemplate = "page_template", e.PageTemplatePreview = "page_template_preview", e.BlogTemplatePreview = "blog_template_preview", e.EmailTemplate = "email_template", e.WebsiteTemplate = "website_template", e.Product = "product", e.FunnelTemplatePreview = "funnel_template_preview", e.DigitalStore = "digital_store", e.DigitalProductResource = "digital_product_resource", e.CalendarHostAvatar = "calendar_host_avatar", e.FileManager = "file_manager", e.WhiteLabel = "white_label", e))(pe || {}), me = /* @__PURE__ */ ((e) => (e.Image = "image", e.ImageOther = "image_other", e.Video = "video", e.Audio = "audio", e.Font = "font", e.Document = "document", e))(me || {});
const Qr = {
  name: "Systeme.io",
  colors: {
    oldBrandPrimary: "#00A0FF",
    oldTextPrimary: "#142D63",
    oldBackgroundPrimary: "#F1F4F8",
    oldBackgroundHeader: "#142D63"
  },
  favicon: {
    id: 0,
    name: "Favicon",
    filename: "Favicon",
    path: "https://d2543nuuc0wvdg.cloudfront.net/images/logo-compact-new.ico",
    thumbnail: null,
    source: pe.WhiteLabel,
    size: 0,
    type: me.Image,
    createdAt: ""
  },
  logo: {
    id: 0,
    name: "Logo",
    filename: "Logo",
    path: "https://d2543nuuc0wvdg.cloudfront.net/images/logo-compact-new.svg",
    thumbnail: null,
    source: pe.WhiteLabel,
    size: 0,
    type: me.Image,
    createdAt: ""
  },
  dashboardHostname: ""
};
export {
  Bt as AbortError,
  ke as AccessDenied,
  je as BadRequest,
  We as ConflictError,
  Xe as ErrorWithFields,
  ge as ErrorWithViolations,
  $e as FailedDependency,
  Ze as InternalError,
  Or as InvalidTokenError,
  Pr as LOCAL_STORAGE_BRAND_DATA_ID,
  ze as LockedError,
  Nt as NetworkError,
  se as NotFound,
  Je as PayloadTooLarge,
  Pt as RequestMethodsEnum,
  Qe as UnauthorizedResponse,
  Ye as UnprocessableContentError,
  X as adjustColorGroup,
  qe as checkAreThereFieldsErrors,
  Mr as createHttpClient,
  Qr as defaultBrandSettings,
  jr as fixFailedToExecuteRemoveChildOnNode,
  Jr as getBrandFromLocalStorage,
  Ur as getErrorMapper,
  Xr as getPercent,
  zr as getRootVarsByBrandColors,
  gt as getTFuncWithNamespace,
  vr as getTICUFuncWithNamespace,
  Gr as getUseBaseFetch,
  Fr as getUseLocoTranslation,
  W as isClient,
  kr as isSioHost,
  Vr as isValidUrl,
  Dr as methodsWithoutBody,
  Wr as replaceWwwForHosts,
  k as semanticColorGroups,
  we as toPercent,
  Zr as useStorage,
  $r as useWatch
};
